import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

import StaffDebtPayments from './Elements/StaffDebtPayments';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Overlay from '../Miscelania/Overlay';

class PaymentDebt extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      payment_order_id: '',
      staff_debts: [],
      payment_orders_list: [],
      checkbox_marked_ids: [],
      data_payment_daily: [],
      check_all_payments: false,
      props_payment_checked: false,
      checkbox_changed: 0,
      modal_props: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.openModal = this.openModal.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);

  }
  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.payment_orders_list)) {
      this.setState({payment_orders_list: newProps.payment_orders_list});
    }
    if(Array.isArray(newProps.staff_debts)) {
      this.setState({staff_debts: newProps.staff_debts});
    }
  }
  
  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-success" value={cell} onClick={this.openModal}>
          <i className="fa fa-fw fa-eye"></i>
        </button>
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );
    
    return botao;
  }
  
  
  openModal (event) {
    var id = event.currentTarget.value;
    var self = this;
    self.handleAlert('', '', 'open');   
    this.setState({ staff_debt_payment_id: event.currentTarget.value});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/saldo/devedor/' + id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.id,
            staff_id: responseJson.data.staff_id,
            staff: responseJson.data.staff,
            schedule_id: responseJson.data.schedule_id,
            schedule: responseJson.data.schedule,
            training_id: responseJson.data.training_id,
            training: responseJson.data.training,
            daily_total: responseJson.data.value_str,
            daily_currency: responseJson.data.currency,
            remaining: responseJson.data.remaining,
            type: responseJson.data.type_str,
            staff_debt_payments: responseJson.data.payments,
            modal: true,
          });

        } 
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse saldo devedor?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/pagamento/saldo/devedor/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  deleteRow(id) {
    var data = this.state.staff_debts;
    data.map(function(dado, index){
      if (dado.id == id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }
  

  render() {
    return (
<div>
    <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
    <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
    <h3 className="page-title pull-left">Saldo devedor</h3>
    <Link to="/pagamentos/saldo/debito/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> Adicionar Saldo Devedor</Link>
    <div className="clearfix"></div>
    <hr/>
    <BootstrapTable data={this.state.staff_debts} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há pagamentos em aberto'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
      <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>
      <TableHeaderColumn dataField="staff" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nome</TableHeaderColumn>
      <TableHeaderColumn dataField="inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Matricula</TableHeaderColumn>
      <TableHeaderColumn dataField="value_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Débito</TableHeaderColumn>
      <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>Ações</TableHeaderColumn>
    </BootstrapTable>
    <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
      <Modal.Header>
        <h4 className="pull-left">Visualização de saldo devedor</h4>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
        <i className="fa fa-fw fa-close"></i></button>
        <div className="clearfix"></div>
      </Modal.Header>
      <Modal.Body>
        <div className="conteudo">

          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label>Tripulante:</label>
                <br/>{this.state.staff}
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Escala / Grade:</label>
                <br/>{this.state.schedule}
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Treinamento:</label>
                <br/>{this.state.training}
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Tipo:</label>
                <br/>{this.state.type}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label>Valor Total:</label>
                <br/>{this.state.daily_total}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Valor Restante:</label>
                <br/>{this.state.remaining}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Moeda:</label>
                <br/>{this.state.daily_currency}
              </div>
            </div>
          </div>
          <StaffDebtPayments handleAlert={this.handleAlert} staff_debt_payment_id={this.state.staff_debt_payment_id} staff_debt_payments={this.state.staff_debt_payments} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
        <i className="fa fa-fw fa-close"></i></button>
      </Modal.Footer>
    </Modal>
</div>
    );
  }
}

export default PaymentDebt;



// WEBPACK FOOTER //
// ./src/Components/TrainingCertificationStaffPayments/PaymentDebt.js